"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexColumn = void 0;
var _react = _interopRequireDefault(require("react"));
var _Flex = require("./Flex.styled");
var PropTypes = _interopRequireWildcard(require("prop-types"));
var _FlexContants = require("./FlexContants");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * This is used to crate a column inside a Flex Grid.
 *
 * @param children The children inside the column
 * @param flex The Flex number this column should use.
 * @param alignItems Align items in column (Optional)
 * @param justifyContent Align items on cross axis (Optional)
 * @param alignSelf Align self on cross axis (Overrides parents alignItems)
 * @param wrap Should the content wrap?
 * @param gap Size of gap e.g. s, m, l etc.
 * @param className For extending the Row component
 * @param data-cy Cypress data tag
 * @returns {JSX.Element} The Column Component
 */
var FlexColumn = function FlexColumn(_ref) {
  var children = _ref.children,
    flex = _ref.flex,
    alignItems = _ref.alignItems,
    justifyContent = _ref.justifyContent,
    alignSelf = _ref.alignSelf,
    wrap = _ref.wrap,
    gap = _ref.gap,
    className = _ref.className,
    dataCy = _ref['data-cy'];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.ColumnContainer, {
    flex: flex,
    alignItems: alignItems,
    justifyContent: justifyContent,
    alignSelf: alignSelf,
    wrap: wrap,
    gap: gap,
    className: className,
    children: children
  });
};
exports.FlexColumn = FlexColumn;
FlexColumn.prototype = {
  children: PropTypes.node.isRequired,
  flex: PropTypes.number,
  alignItems: PropTypes.oneOf(Object.keys(_FlexContants.FLEX_ALIGN_ITEMS)),
  gap: PropTypes.string,
  'data-cy': PropTypes.string
};